export default __webpack_public_path__ + "static/media/better-payment.43daf361.png";